export function formatDate(timestamp) {
  if (!timestamp?.toDate) return '';
  const date = timestamp.toDate();
  return date.toLocaleString('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

export function formatRelativeTime(timestamp) {
  if (!timestamp?.toDate) return '';
  const now = new Date();
  const then = timestamp.toDate();
  const diff = Math.abs(Math.floor((now - then) / 1000)); // seconds

  if (diff < 60) return `${diff}s ago`;
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
}
